import { menuselect, getrouteparams } from "@/constant/menuselect";
let str = "HRP系统中部分核心产品";
export const config = {
  title: "敬在HRP",
  headerInfo:
    "敬在全新一代智慧运营管理平台融合“平台、连接、数据、智能”建设思想，提供医院级 PaaS 平台支撑、以混合云 SaaS 模式提供管理应用系统，建设HRP智慧管理平台 DaaS 模式的智慧大脑的三层系统架构，以管理会计和数据中台为主线实现数据驱动，重新定义医院运营管理平台",
  headerImg: require("@/assets/images/hpr_system/Rectangle19top.svg"),
  activeTitle: str,
  activeSubTitle:str,
  navList: [
    {
      name: "敬在HRP",
      children: menuselect(),
    },

    {
      name: "HRP智慧管理平台",
      desc: "敬在全新一代智慧运营管理平台融合“平台、连接、数据、智能”建设思想，提供医院级 PaaS 平台支撑、以混合云 SaaS 模式提供管理应用系统，建设运营数据中心 DaaS 模式的智慧大脑的三层系统架构，以管理会计和数据中台为主线实现数据驱动，重新定义医院运营管理平台。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/hpr_system/Group 1094one.svg"),
        },
        {
          title: "敬在产品蓝图",
          desc: "一条主线：医院运营管理主线；四大技术平台：基于HRP标准套件上的快速开发平台、基于SaaS的云应用聚合平台、基于EMP的移动应用聚合平台、基于EnoDate的数据服务平台。",
          img: require("@/assets/images/hpr_system/Frame 1098one1.png"),
        },
        {
          title: "敬在HRP-支持医院通过智慧管理更高级别",
          desc: " ",
          img: require("@/assets/images/hpr_system/Frame 1143one2.png"),
        },
      ],
    },
    {
      name: "产品蓝图",
      desc: "敬在信息结合医院运营管理实际业务场景，应用前沿信息技术，在医院数字化建设中自主研发出拥有自主知识产权的医院级 PaaS 平台，平台采用云原生微服务架构，集技术、管理、连接、数据中台能力为一体，实现跨组织、跨系统、跨业务的多维协同。它是一套伴随客户成长可拓展的运营支撑体系，一个巨大的应用生态系统，作为开源的企业级管理平台，可以为客户在数字化过程中节省大量开支，规范整个企业管理数字化路径。",
      tabList: [{ name: "HRP系统中部分核心产品" }, { name: "HRP移动端应用" }],
      HRP系统中部分核心产品: [
        { img: require("@/assets/images/hpr_system/Frame 1102hrp1.png") },
        { img: require("@/assets/images/hpr_system/Frame 1102hrp2.png") },
        { img: require("@/assets/images/hpr_system/Frame 1103hrp3.png") },
        { img: require("@/assets/images/hpr_system/Frame 1103hrp4.png") },
        { img: require("@/assets/images/hpr_system/Frame 1103hrp5.png") },
        { img: require("@/assets/images/hpr_system/Frame 1103hrp6.png") },
        { img: require("@/assets/images/hpr_system/Frame 1103hrp7.png") },
        { img: require("@/assets/images/hpr_system/Frame 1103hrp8.png") },
        { img: require("@/assets/images/hpr_system/Frame 1103hrp9.png") },
      ],
      HRP移动端应用: [
        { img: require("@/assets/images/hpr_system/Frame 1103hrp-m1.png") },
        { img: require("@/assets/images/hpr_system/Frame 1103hrp-m2.png") },
      ],
    },

    {
      name: "平台概述",
      desc: "敬在信息结合医院运营管理实际业务场景，应用前沿信息技术，在医院数字化建设中自主研发出拥有自主知识产权的医院级 PaaS 平台，平台采用云原生微服务架构，集技术、管理、连接、数据中台能力为一体，实现跨组织、跨系统、跨业务的多维协同。它是一套伴随客户成长可拓展的运营支撑体系，一个巨大的应用生态系统，作为开源的企业级管理平台，可以为客户在数字化过程中节省大量开支，规范整个企业管理数字化路径。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/hpr_system/Group 1094four.svg"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/hpr_system/Group 1094four-1.svg"),
        },
      ],
    },
    {
      name: "技术优势",
      desc: "敬在信息拥有自主知识产权的PaaS 开发平台，采用成熟的、国际先进的J2EE和数据库技术，云原生微服务架构，可实现跨系统、跨业务、多维协同，全面的可视化开发和全组件化开发体系，可快速重构运营管理数字化系统，真正实现医院运营管理平台的价值。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/hpr_system/Frame 1099four1.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/hpr_system/Group 788four2.png"),
        },
      ],
    },
  ],
};
